import _toConsumableArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import _styled from "styled-components";
import React from 'react';
import Paragraph from '../paragraph';
import Title from '../title';
import { SkeletonTextLoading } from '../skeleton-loading';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var PresentationCard = function PresentationCard(_ref) {
  var _ref$isError = _ref.isError,
      isError = _ref$isError === void 0 ? false : _ref$isError,
      icon = _ref.icon,
      label = _ref.label,
      header = _ref.header,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? 'start' : _ref$variant,
      _ref$hide = _ref.hide,
      hide = _ref$hide === void 0 ? false : _ref$hide,
      contentStyling = _ref.contentStyling,
      loading = _ref.loading,
      headerStyling = _ref.headerStyling,
      maxChars = _ref.maxChars;
  return /*#__PURE__*/_jsxs(Wrapper, {
    variant: variant,
    hide: hide,
    children: [/*#__PURE__*/_jsx(IconContainer, {
      isError: isError,
      variant: variant,
      children: icon
    }), /*#__PURE__*/_jsxs(ContentContainer, {
      contentStyling: contentStyling,
      children: [loading ? /*#__PURE__*/_jsx(SkeletonTextLoading, {
        width: "small"
      }) : typeof label !== 'string' ? label : /*#__PURE__*/_jsx(Paragraph, {
        font: variant === 'center' ? 'normal' : 'medium',
        color: variant === 'center' ? 'gray-600' : 'black',
        variant: variant === 'center' ? 'xsmall' : 'small',
        children: label
      }), loading ? /*#__PURE__*/_jsx(_StyledSkeletonTextLoading, {
        width: "medium"
      }) : typeof header !== 'string' ? header : /*#__PURE__*/_jsx(Title, {
        fontWeight: variant === 'center' ? 'semibold' : 'normal',
        textColor: isError ? 'red' : variant === 'center' ? 'black' : 'gray-500',
        variant: "h6-large",
        twStyle: headerStyling,
        content: header,
        maxChars: maxChars
      })]
    })]
  });
};

var Wrapper = /*#__PURE__*/_styled.div.withConfig({
  displayName: "presentation-card__Wrapper",
  componentId: "sc-1lec9cq-0"
})(function (_ref2) {
  var variant = _ref2.variant,
      hide = _ref2.hide;
  return [{
    "display": "flex",
    "width": "100%",
    "maxWidth": "100%",
    "flexDirection": "row",
    "alignItems": "flex-start",
    "justifyContent": "flex-start",
    "gap": "0.5rem"
  }, variant === 'center' && {
    "alignItems": "center"
  }, hide && {
    "display": "none"
  }];
});

var IconContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "presentation-card__IconContainer",
  componentId: "sc-1lec9cq-1"
})(function (_ref3) {
  var isError = _ref3.isError,
      variant = _ref3.variant;
  return [{
    "display": "flex",
    "height": "2.5rem",
    "width": "2.5rem",
    "minWidth": "40px",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "borderRadius": "0.5rem",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
    "--tw-text-opacity": "1",
    "color": "rgb(105 62 181 / var(--tw-text-opacity))"
  }, variant === 'center' && {
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(246 245 255 / var(--tw-bg-opacity))"
  } // It is tricky to color the native SVG icons, this will be covered later
  // isError && tw`text-red-600`,
  ];
});

export var ContentContainer = /*#__PURE__*/_styled.div.withConfig({
  displayName: "presentation-card__ContentContainer",
  componentId: "sc-1lec9cq-2"
})(function (_ref4) {
  var twStyle = _ref4.contentStyling;
  return [{
    "display": "flex",
    "flex": "1 1 0%",
    "flexDirection": "column",
    "alignItems": "flex-start"
  }].concat(_toConsumableArray(twStyle && Array.isArray(twStyle) ? twStyle : []), [twStyle && !Array.isArray(twStyle) ? twStyle : {}]);
});

var _StyledSkeletonTextLoading = /*#__PURE__*/_styled(SkeletonTextLoading).withConfig({
  displayName: "presentation-card___StyledSkeletonTextLoading",
  componentId: "sc-1lec9cq-3"
})({
  "marginTop": "0.5rem"
});